import logo from './exergyheat.png';
import './App.css';
import CalculateRevenue from './components/CalculateRevenue';

function App() {
  return (
    <div className="Hashrateheating">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <CalculateRevenue />
      </header>
    </div>
  );
}

export default App;
